import React, { Component } from 'react';
import {
  Redirect,
  NavLink,
} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import Loader from '../../components/Loader';
import { auth } from '../../config/firebase';
import images from '../../images';
import NewPostButton from './components/NewPostButton';

import Resources from './scenes/Resources';
import Practices from './scenes/Practices';
import GuidedMeditation from './scenes/GuidedMeditation';
import DharmaTalks from './scenes/DharmaTalks';
import BellOfMindfulness from './scenes/BellOfMindfulness';
import Media from './scenes/Media';
import LinkGenerator from './scenes/LinkGenerator';

import './styles.css';

const screens = [
  {
    path: 'resources',
    title: 'Resources',
    component: Resources,
  },
  {
    path: 'practices',
    title: 'Practices',
    component: Practices,
  },
  {
    path: 'guidedMeditation',
    title: 'Guided Meditation',
    component: GuidedMeditation,
  },
  {
    path: 'dharmaTalks',
    title: 'Ask Thay',
    component: DharmaTalks,
  },
  {
    path: 'bellOfMindfulness',
    title: 'Bell of Mindfulness',
    component: BellOfMindfulness,
  },
  {
    path: 'media',
    title: 'Media',
    component: Media,
  },
  {
    path: 'linkGenerator',
    title: 'Link Generator',
    component: LinkGenerator,
  },
];

const drawerWidth = 240;

const styles = theme => ({
  dashboard: {
    width: '100%',
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'stretch',
  },
  appBar: {
    position: 'absolute',
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
    },
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    background: '#fff',
    color: 'inherit',
    boxShadow: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  flex: {
    flex: 1,
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    color: '#fff',
    background: '#607d8b',
    borderRight: 0,
  },
  brandWrap: {
    padding: '20px 15px',
    textAlign: 'center',
    background: 'rgba(0,0,0,0.15)',
  },
  brandImg: {
    maxWidth: 128,
    height: 'auto',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
  },
  userImg: {
    width: 32,
    marginRight: 7,
    borderRadius: '50%',
  },
  navLink: {
    display: 'block',
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing.unit * 3,
    },
    color: 'rgba(255, 255, 255, 0.8)',
    textDecoration: 'none',
    '&:hover, &.active': {
      color: '#757575',
      background: '#e0e0e0',
    },
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
    },
    maxWidth: 700,
    padding: theme.spacing.unit * 3,
  },
});

class Dashboard extends Component {
  state = {
    mobileOpen: false,
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const { classes } = this.props;

    if ( !this.props.user ) {
      return (
        <Loader />
      )
    }

    const matches = screens.filter((screen) => (screen.path === this.props.matchParams.screen));
    if (matches.length < 1) {
      return (
        <Redirect to='/404'/>
      )
    }
    const currentScreen = matches[0];

    const navLinks = screens.map(screen => (
      <NavLink
        key={screen.path}
        className={classes.navLink}
        activeClassName="active"
        to={`/${screen.path}`}
      >
        {screen.title}
      </NavLink>
    ));

    const drawer = (
      <div>
        <header>
          <div className={classes.brandWrap}>
            <img className={classes.brandImg} src={images.logo} alt="logo"/>
          </div>
        </header>
        <Divider />
        <nav>
          {navLinks}
        </nav>
      </div>
    );

    return (
      <div className={classes.dashboard}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="primary"
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <Icon>menu</Icon>
            </IconButton>
            <Typography variant="title" noWrap className={classes.flex}>
              <div>{currentScreen.title} <NewPostButton {...this.props.matchParams} /></div>
            </Typography>
            <div className={classes.user}>
              <img className={classes.userImg} src={this.props.user.photoURL} alt="user"/>
              <Button color="secondary" onClick={() => (auth.signOut())}>Sign out</Button>
            </div>
          </Toolbar>
        </AppBar>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor="left"
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {React.createElement(currentScreen.component, this.props.matchParams)}
        </main>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Dashboard);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/index.js